const STORAGE_DOWNLOAD_BASE =
  "https://firebasestorage.googleapis.com/v0/b/brollerteam.firebasestorage.app/o/";

function getStoragePath(src) {
  if (typeof src !== "string") return null;

  const gsPath = src.match(/^gs:\/\/[^/]+\/(.+)$/);
  if (gsPath) return gsPath[1];

  try {
    const url = new URL(src);
    const encodedPath = url.pathname.match(/\/o\/([^?]+)/);

    return encodedPath ? decodeURIComponent(encodedPath[1]) : null;
  } catch (e) {
    return src.startsWith("levels/") ? src : null;
  }
}

function getLevelImageUrl(src) {
  const storagePath = getStoragePath(src);

  if (!storagePath || !storagePath.startsWith("levels/")) {
    return src || "";
  }

  try {
    const url = new URL(src);

    if (
      url.hostname === "firebasestorage.googleapis.com" &&
      url.pathname.includes("/b/brollerteam.firebasestorage.app/") &&
      url.searchParams.get("token")
    ) {
      return src;
    }
  } catch (e) {
    // Plain storage paths are handled below.
  }

  return `${STORAGE_DOWNLOAD_BASE}${encodeURIComponent(storagePath)}?alt=media`;
}

export function getAwardImage({ isOpened, level }) {
  const field = isOpened ? "awardOpenedPicture" : "awardClosedPicture";
  const state = isOpened ? "opened" : "closed";
  const src =
    (level && level[field]) ||
    (level && level.id && `levels/${level.id}-${state}.png`);

  return getLevelImageUrl(src);
}
